<template>
  <div class="layout">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <el-row>
      <el-col :span="5" style="height: calc(100vh - 64px); overflow: auto;">
        <div v-for="chart in gdsList" @click="pickChart(chart)" :key="chart.name" :class="{ active: selectChart.name === chart.name, inactive: selectChart.name !== chart.name }">{{ chart.name }}</div>
      </el-col>
      <el-col :span="19" style="text-align: left; position: relative;">
        <iframe width="100%" :src="selectChart.link"
          frameborder="0" style="border: 0; height: calc(100vh - 64px)" allowfullscreen>
        </iframe>
        <div style="width: 100%; background-color: #fafafa; font-weight: 500; position: absolute; right: 0px; top: calc(100vh - 90px); z-index: 5000; padding-top: 20px; padding-bottom: 10px; padding-right: 20px; text-align: right;"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      gdsList: [],
      selectChart: {
        name: '',
        link: ''
      }
    }
  },
  mounted() {
    const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
    this.getGDSData({ service: this.service, auth: this.auth })
      .then((res) => {
        loading.close();
        this.gdsList = res.data.list.list;
      })
  },
  methods: {
    ...mapActions({
      getGDSData: 'getGDSData'
    }),
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    pickChart(chart) {
      this.selectChart = chart;
    }
  }
}
</script>

<style scoped>
.layout {
  min-width: 100%;
  max-width: 100%;
  padding-top: 60px;
  margin-left: 0!important;
  flex: 1 1 100%;
}
.layout-66 {
  border-radius: 6px;
  background: #ffffff;
  height: 500px;
  min-width: 66.6666%;
  max-width: 66.6666%;
  flex: 0 1 66.6666%;
}
.active {
  padding: 20px 0px;
  color: #fff;
  font-size: 16px;
  width: 100%;
  font-weight: 600;
  border-bottom: 1px solid #fff;
  background-color: #079feb;
  cursor: pointer;
}
.inactive:hover {
  background-color: #079feb;
}
.inactive {
  padding: 20px 0px;
  width: 100%;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  border-bottom: 1px solid #fff;
  background-color: #4ec1f2;
  cursor: pointer;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
.layout-33 {
  height: 500px;
  background: #ffffff;
  min-width: 100px;
  max-width: 400px;
  flex: 0 1 33.3333%;
}

</style>